module.exports = __webpack_public_path__ + "static/media/confirmDelete.cd49fc9c.svg";